import { format, isAfter, isBefore, isEqual } from 'date-fns';

export const commonDateFormat = 'dd/MM/yyyy';

export const isoDateFormat = 'yyyy-MM-dd';

export const ordinalDateFormat = 'do MMM yyyy';

export const longDateFormat = 'dd MMM yyyy';

export const apiDateFormat = "yyyy-MM-dd'T'HH:mm:ss";

/**
 * The api needs date to be formatted in a specific way
 *  - no timezone info (api does not support timezone)
 *  - format is essentially ISO 8601 without timezone info
 *
 */
export function formatDateForAPI(date: string | Date): string {
  return format(new Date(date), apiDateFormat);
}

/**
 * Check if the `targetDate` is the same as or occurs after the `dateToCompare`
 *
 * _This function uses the same parameter order as `date-fns` `isAfter`_
 */
export function isSameOrAfter(targetDate: Date, dateToCompare: Date): boolean {
  return isEqual(targetDate, dateToCompare) || isAfter(targetDate, dateToCompare);
}

/**
 * Check if the `targetDate` is the same as or occurs before the `dateToCompare`
 *
 * _This function uses the same parameter order as `date-fns` `isBefore`_
 */
export function isSameOrBefore(targetDate: Date, dateToCompare: Date): boolean {
  return isEqual(targetDate, dateToCompare) || isBefore(targetDate, dateToCompare);
}
